export default __webpack_public_path__ + "static/media/ic_notif_reject.f301b28a.svg";